import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';
import { Button, InputGroup, FormControl, Dropdown, DropdownButton } from 'react-bootstrap';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import PageComponent from '../components/PageComponent';
import AppStorage from '../config/AppStorage';
import Labels from '../Labels';

export default class UserPage extends PageComponent {

  static PageInfo = {

    show: false,
    path: "/MyUser",
    name: "menu.myuser",
    access: { 1: true, 2: true },
    icon: "user"
  }

  options = [
    //   {
    //   label: "myuser.edit",
    //   action: () => { },
    //   icon: "pencil-alt"
    // }, {
    //   label: "myuser.password",
    //   action: () => { },
    //   icon: "key"
    // },
    {
      label: "myuser.signout",
      action: () => {
        AppStorage.ClearUserCredentials(); window.location.reload();
      },
      icon: "sign-out-alt"
    }]

  constructor(props) {
    super(props);
    this.state.user = global.user;
  }

  renderPersonalInfo(target, label) {
    var c = GenericHelper.parseInformation(this.state.user.personValue, target, "valueType", null);
    return c == null ? null :
      <div className="generics_infobox">
        <div className="generics_infobox_label">{label}</div>
        <div className="generics_infobox_value">{c}</div>
      </div>;
  }

  render() {
    return (
      <Container context={this.constructor}>
        <div className="generics_panels">
          <div className="generics_panels_sizeless">
            <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
            <div>
              {/* <div className="generics_infobox">
                <div className="generics_infobox_label">{Labels.GetLabel("myuser.company")}</div>
                <div className="generics_infobox_value">{this.state.user.mainCompany.name}</div>
              </div> */}
              {/* <div className="generics_infobox">
                <div className="generics_infobox_label">{Labels.GetLabel("information.DOC_CNPJ")}</div>
                <div className="generics_infobox_value">{Parsers.parseCPNJ(this.state.user.mainCompany.criticalValue)}</div>
              </div> */}
              <div style={{ clear: "both" }}></div>
              <div className="generics_infobox">
                <div className="generics_infobox_label">{Labels.GetLabel("myuser.username")}</div>
                <div className="generics_infobox_value">{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.user.personValue, 1, "valueType"))}</div>
              </div>
              <div className="generics_infobox">
                <div className="generics_infobox_label">{Labels.GetLabel("myuser.email")}</div>
                <div className="generics_infobox_value">{GenericHelper.parseInformation(this.state.user.personValue, 3, "valueType")}</div>
              </div>
              <div style={{ clear: "both" }}></div>
              {this.renderPersonalInfo(13, Labels.GetLabel("information.NAME_TITLE"))}
              {this.renderPersonalInfo(18, Labels.GetLabel("information.DEPARTAMENT"))}
              {this.renderPersonalInfo(16, Labels.GetLabel("information.REGISTER"))}
              <div style={{ clear: "both" }}></div>
            </div>
          </div>
          <div className="generics_panels_flex1">
            <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("myuser.options")}</span></div>
            {this.options.map((item) =>
              <Link onClick={() => item.action()} className="generics_listing_item" >
                <FontAwesomeIcon icon={item.icon} className="generics_listing_item_icon" />
                <div className="generics_listing_content" >
                  <div className="generics_listing_item_title" >{Labels.GetLabel(item.label)}</div>
                </div>
              </Link>
            )}
          </div>
        </div>
      </Container>
    );
  }
} 